import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";

export default function BookingSuccess() {
  const { reference } = useParams();
  const { t } = useTranslation();
  const [b, setB] = useState(null);
  useEffect(() => {
    api.get(`/bookings/public/${reference}`).then(({ data }) => setB(data)).catch(() => setB(false));
  }, [reference]);

  return (
    <section className="section bg-paper">
      <div className="container-x max-w-2xl text-center" data-testid="booking-success-page">
        <CheckCircle2 size={56} className="mx-auto text-[color:var(--brand)]" />
        <h1 className="font-heading text-4xl md:text-5xl mt-4">{t("booking.successTitle")}</h1>
        <p className="mt-3 opacity-80">{t("booking.successBody")}</p>
        {b && b !== false && (
          <div className="mt-8 card-elevated rounded-md p-6 text-left">
            <div className="grid sm:grid-cols-2 gap-3 text-sm">
              <Row k={t("booking.reference")} v={b.reference} />
              <Row k="Pooja" v={b.pooja_name} />
              <Row k="Date" v={b.booking_date} />
              <Row k="Devotee" v={b.devotee_name} />
              {b.deposit_required && (
                <Row k="Payment Status" v={b.payment_status} />
              )}
            </div>
          </div>
        )}
        <Link to="/" className="mt-8 inline-flex items-center gap-2 px-5 py-2.5 rounded-full btn-brand text-sm" data-testid="back-home-btn">
          Return Home <ArrowRight size={14} />
        </Link>
      </div>
    </section>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex flex-col">
      <span className="text-xs uppercase tracking-[0.18em] opacity-60">{k}</span>
      <span className="mt-0.5">{v}</span>
    </div>
  );
}
